import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { map, catchError } from 'rxjs/operators'
import { Observable, throwError } from 'rxjs';
import { MSignInResponse } from 'src/app/pages/sign-in/sign-in.module';
import { MSignUpRequest, MSignUpResponse, MUpdateUserRequest } from 'src/app/pages/sign-up/sign-up.module';

@Injectable({
  providedIn: 'root'
})
export class WsSignInService {

  constructor(private httpClient: HttpClient) { }

  /**
  * Date:- 08-06-2023
  * Method :- This method is used for Get OTP
  * @param {{phone_number}} :-  This param is used for Get OTP
  * @returns 
  */
   getOtp(phone_number: any): Observable<MSignInResponse> {
    const phoneNumber = "phoneNumber=" + phone_number;
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
    return this.httpClient.get<MSignInResponse>(UtilsService.BASE_URL + UtilsService.GETOTP + "?" + phoneNumber,  httpOptions).pipe(
      map((response: any) => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
  * Date:- 08-06-2023
  * Method :- This method is used for Verify OTP
  * @param {{phone_number}} :-  This param is used for Get OTP
  * @param {{verifyOtp}} :-  This param is used for verify OTP
  * @returns 
  */
  getVerifyOtp(phonenumber:any,verifyOtp: any): Observable<MSignInResponse> {
    const otp = "otp=" + verifyOtp;
    const phoneNumber = "phoneNumber=" + phonenumber;
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
    return this.httpClient.get<MSignInResponse>(UtilsService.BASE_URL + UtilsService.VERIFYOTP + "?" + phoneNumber + "&" + otp,  httpOptions).pipe(
      map(response => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
  * Date:- 08-06-2023
  * Method :- This method is used for Verify OTP
  * @param {{phone_number}} :-  This param is used for Get OTP
  * @param {{verifyOtp}} :-  This param is used for verify OTP
  * @returns 
  */
  loginWithOTP(phonenumber:any,verifyOtp: any): Observable<MSignInResponse> {
    const otp = "otp=" + verifyOtp;
    const phoneNumber = "phoneNumber=" + phonenumber;
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
    return this.httpClient.get<MSignInResponse>(UtilsService.BASE_URL + UtilsService.LOGIN_WITH_OTP + "?" + phoneNumber + "&" + otp,  httpOptions).pipe(
      map(response => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  /**
  * Date:- 08-06-2023
  * Method :- This method is used for Add User 
  * @param MSignUpRequest :-  This is used for Add User Details 
  * @returns 
  */
  addUser(adduser: MSignUpRequest): Observable<MSignUpResponse> {
    var jsonBody = JSON.stringify(adduser)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MSignUpResponse>(UtilsService.BASE_URL + UtilsService.ADDUSER, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /**
  * Date:- 08-06-2023
  * Method :- This method is used for Add User 
  * @param MSignUpRequest :-  This is used for Add User Details 
  * @returns 
  */
  updateUser(adduser: MUpdateUserRequest): Observable<MSignInResponse> {
    var jsonBody = JSON.stringify(adduser)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MSignInResponse>(UtilsService.BASE_URL + UtilsService.UPDATE_PROFILE, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
}
